function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "s807mmxz6a",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#s807mmxz6a)",
  transform: "translate(-280.000000, -232.000000) translate(0.000000, 216.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(280.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  stroke: "#9E9E9E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9E9E9E",
  d: "M6 7H7V11H6zM9 7H10V11H9z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#9E9E9E",
  strokeLinejoin: "round",
  d: "M13 7L3 7 3 5.5 8 4 13 5.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#9E9E9E",
  strokeLinecap: "round",
  d: "M3.5 11L12.5 11"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#9E9E9E",
  strokeLinejoin: "round",
  d: "M4 7H12V11H4z"
})))));
const SvgUiIconUtility16GovCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility16GovCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-gov-circle.ecd5f279.svg";
export { ForwardRef as ReactComponent };